function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
// cspell:words QWILT EDGIO caas MEDIACDN
import { CoreVideoInternal } from '../../core-video-internal';
import { sdkLogger } from '../../logger';
import { JsonUtils } from '../../utils/json-utils';
import { TestingOverrides } from '../services/testing-overrides';
import { UpdateType } from './meta-list.enums';
var KnownCdns = {
    LIMELIGHT: 'll',
    EDGIO: 'll',
    // note: Peacock uses the name LIMELIGHT for this CDN, but Showmax uses EDGIO
    FASTLY: 'fy',
    CLOUDFRONT: 'cf',
    AKAMAI: 'ak',
    COMCAST: 'cc',
    LEVEL3: 'cl',
    GOOGLE: 'mc',
    MEDIACDN: 'mc',
    QWILT: 'qw'
};
var CDN_URL_PATHNAME = '/metalist/api/v1/';
var LOOPING_TIME_MS = 4000;
var MIN_FETCH_TIMEOUT_MS = 3000;
export var MetaListManager = /*#__PURE__*/ function() {
    "use strict";
    function MetaListManager(notifyWarning, providerVariantId) {
        var _this = this;
        var minTimeoutMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : MIN_FETCH_TIMEOUT_MS;
        _class_call_check(this, MetaListManager);
        var _this1 = this;
        _define_property(this, "notifyWarning", void 0);
        _define_property(this, "providerVariantId", void 0);
        _define_property(this, "minTimeoutMs", void 0);
        _define_property(this, "logger", void 0);
        _define_property(this, "metaListInstructionPollingTimeout", void 0);
        _define_property(this, "callBacks", void 0);
        _define_property(this, "primaryCdn", void 0);
        _define_property(this, "cdns", void 0);
        _define_property(this, "options", void 0);
        _define_property(this, "startIndex", void 0);
        _define_property(this, "isRequestPending", void 0);
        _define_property(this, "updateType", void 0);
        _define_property(this, "abortController", void 0);
        _define_property(this, "shouldAbort", void 0);
        _define_property(this, "makeRequest", void 0);
        _define_property(this, "metaListPollingCycleHandler", void 0);
        _define_property(this, "stopMetaListInstructionPolling", void 0);
        _define_property(this, "destroy", void 0);
        this.notifyWarning = notifyWarning;
        this.providerVariantId = providerVariantId;
        this.minTimeoutMs = minTimeoutMs;
        this.logger = sdkLogger.withContext('MLM');
        this.metaListInstructionPollingTimeout = undefined;
        this.callBacks = [];
        this.cdns = [];
        this.startIndex = 0;
        this.isRequestPending = false;
        this.updateType = UpdateType.NO_UPDATE;
        this.shouldAbort = {
            abortTimerHit: false,
            manifestHasUpdated: false
        };
        this.makeRequest = /*#__PURE__*/ _async_to_generator(function() {
            var i, cdns, options, currentIndex, currentCdn, cdnMetaListUrl, timeoutId, response, jsonResponse, success, j, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (_this1.callBacks.length === 0 || _this1.isRequestPending) {
                            return [
                                2
                            ];
                        }
                        _this1.isRequestPending = true;
                        i = 0;
                        cdns = _this1.cdns, options = _this1.options;
                        _this1.clearShouldAbort();
                        _state.label = 1;
                    case 1:
                        if (!(i < cdns.length)) return [
                            3,
                            7
                        ];
                        // Do this to start in middle of array and loop back to beginning if necessary
                        currentIndex = (i + _this1.startIndex) % cdns.length;
                        currentCdn = cdns[currentIndex];
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            5,
                            ,
                            6
                        ]);
                        cdnMetaListUrl = _this1.getRequestUrl(currentCdn);
                        if (!cdnMetaListUrl) {
                            return [
                                3,
                                6
                            ];
                        }
                        _this1.abortController = new AbortController();
                        timeoutId = setTimeout(function() {
                            return _this1.abortControllerManager(true);
                        }, _this1.minTimeoutMs);
                        return [
                            4,
                            fetch(cdnMetaListUrl, _object_spread_props(_object_spread({}, options), {
                                signal: _this1.abortController.signal
                            }))
                        ];
                    case 3:
                        response = _state.sent();
                        clearTimeout(timeoutId);
                        if (!response.ok) {
                            _this1.notifyWarning('METALIST', "".concat(currentCdn.name, " - ").concat(response.statusText));
                            _this1.logger.warn("Error in meta list instructions response: ".concat(response.statusText));
                            return [
                                3,
                                6
                            ];
                        }
                        return [
                            4,
                            response.json()
                        ];
                    case 4:
                        jsonResponse = _state.sent();
                        if (jsonResponse) {
                            success = true;
                            for(j = 0; j < _this1.callBacks.length; j++){
                                success = _this1.callBacks[j](jsonResponse, currentCdn.name);
                                if (!success) {
                                    break;
                                }
                            }
                            if (success) {
                                _this1.startIndex = currentIndex;
                                // Only get the first successful response
                                return [
                                    3,
                                    7
                                ];
                            } else {
                                _this1.notifyWarning('METALIST', "".concat(currentCdn.name, " - ").concat(response.statusText));
                                _this1.logger.warn("Meta list instructions response unexpected format: ".concat(response.statusText));
                            }
                        }
                        return [
                            3,
                            6
                        ];
                    case 5:
                        error = _state.sent();
                        _this1.notifyWarning('METALIST', "".concat(currentCdn.name, " - ").concat(JsonUtils.stringify(error)));
                        _this1.logger.warn("Error fetching meta list instructions: ".concat(JsonUtils.stringify(error)));
                        return [
                            3,
                            6
                        ];
                    case 6:
                        i++;
                        return [
                            3,
                            1
                        ];
                    case 7:
                        if (i === cdns.length) {
                            // If we reach here, we didn't break the loop
                            // i.e. all of the requests failed
                            _this1.notifyWarning('METALIST', "METALIST CDNS EXHAUSTED");
                            _this1.startIndex = 0;
                        }
                        _this1.isRequestPending = false;
                        return [
                            2
                        ];
                }
            });
        });
        this.metaListPollingCycleHandler = /*#__PURE__*/ _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this1.makeRequest()
                        ];
                    case 1:
                        _state.sent();
                        _this1.stopMetaListInstructionPolling();
                        // Regardless of failure or success, set new timeout
                        if (_this1.updateType === UpdateType.TIMELINE_UPDATE) {
                            _this1.metaListInstructionPollingTimeout = setTimeout(function() {
                                _this1.metaListPollingCycleHandler();
                            }, LOOPING_TIME_MS);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        this.stopMetaListInstructionPolling = function() {
            clearTimeout(_this.metaListInstructionPollingTimeout);
            _this.metaListInstructionPollingTimeout = undefined;
        };
        this.destroy = function() {
            _this.updateType = UpdateType.NO_UPDATE;
            _this.stopMetaListInstructionPolling();
        };
    }
    _create_class(MetaListManager, [
        {
            key: "handleManifestUpdated",
            value: function handleManifestUpdated() {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.updateType = UpdateType.MANIFEST_UPDATE;
                                _this.stopMetaListInstructionPolling();
                                if (!!_this.isRequestPending) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.makeRequest()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                _this.abortControllerManager(false);
                                _state.label = 3;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "clearShouldAbort",
            value: function clearShouldAbort() {
                this.shouldAbort.abortTimerHit = false;
                this.shouldAbort.manifestHasUpdated = false;
            }
        },
        {
            key: "abortControllerManager",
            value: function abortControllerManager(isTimer) {
                if (isTimer) {
                    this.shouldAbort.abortTimerHit = true;
                } else {
                    this.shouldAbort.manifestHasUpdated = true;
                }
                if (this.updateType === UpdateType.TIMELINE_UPDATE || Object.values(this.shouldAbort).every(Boolean)) {
                    var _this_abortController;
                    this.clearShouldAbort();
                    (_this_abortController = this.abortController) === null || _this_abortController === void 0 ? void 0 : _this_abortController.abort();
                }
            }
        },
        {
            key: "registerCallBack",
            value: function registerCallBack(callBack) {
                this.callBacks.push(callBack);
            }
        },
        {
            key: "setPrimaryCdn",
            value: function setPrimaryCdn(cdn) {
                this.primaryCdn = cdn;
            }
        },
        {
            key: "handleStartPooling",
            value: function handleStartPooling(cdns, options) {
                var startIndex = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                this.cdns = getPrioritizedCdns(this.primaryCdn, cdns);
                this.options = options;
                this.startIndex = startIndex;
                if (this.updateType === UpdateType.NO_UPDATE) {
                    this.updateType = UpdateType.TIMELINE_UPDATE;
                    this.metaListPollingCycleHandler();
                }
            }
        },
        {
            key: "getRequestUrl",
            value: function getRequestUrl(currentCdn) {
                var _CoreVideoInternal_getPropositionExtensions_coordinatedBitrateCapping, _CoreVideoInternal_getPropositionExtensions, _cdnUrl_match;
                var metalistEndpointOverride = TestingOverrides.metalistEndpointOverride;
                if (metalistEndpointOverride) {
                    return metalistEndpointOverride;
                }
                var cdnAbbreviation = KnownCdns[currentCdn.name];
                var cappingUrlData = (_CoreVideoInternal_getPropositionExtensions = CoreVideoInternal.getPropositionExtensions()) === null || _CoreVideoInternal_getPropositionExtensions === void 0 ? void 0 : (_CoreVideoInternal_getPropositionExtensions_coordinatedBitrateCapping = _CoreVideoInternal_getPropositionExtensions.coordinatedBitrateCapping) === null || _CoreVideoInternal_getPropositionExtensions_coordinatedBitrateCapping === void 0 ? void 0 : _CoreVideoInternal_getPropositionExtensions_coordinatedBitrateCapping.urlPieces;
                if (!cappingUrlData || !cdnAbbreviation) {
                    return '';
                }
                var _currentCdn_originalUrl;
                var cdnUrl = (_currentCdn_originalUrl = currentCdn.originalUrl) !== null && _currentCdn_originalUrl !== void 0 ? _currentCdn_originalUrl : currentCdn.url;
                // prod uses both original url and url, stable-int has only url
                var domainBase = cappingUrlData.domainBase, domainMid = cappingUrlData.domainMid, domainProd = cappingUrlData.domainProd, domainStage = cappingUrlData.domainStage, host = cappingUrlData.host;
                var _cdnUrl_match_;
                var domainNumber = (_cdnUrl_match_ = (_cdnUrl_match = cdnUrl.match('^https://[a-z][0-9][0-9]([0-9])')) === null || _cdnUrl_match === void 0 ? void 0 : _cdnUrl_match[1]) !== null && _cdnUrl_match_ !== void 0 ? _cdnUrl_match_ : '1';
                var domainPrdOrStg = cdnUrl.slice(0, cdnUrl.indexOf(host)).includes(domainStage) ? domainStage : domainProd;
                return "".concat(domainBase).concat(domainNumber).concat(domainMid).concat(domainPrdOrStg).concat(cdnAbbreviation, ".").concat(host).concat(CDN_URL_PATHNAME).concat(this.providerVariantId);
            }
        }
    ]);
    return MetaListManager;
}();
/**
 * Helper method to move primary Cdn to the start of the cdns list.
 * @param cdns List of cdns to re-prioritize.
 * @returns If the primaryCdn url is not found (e.g. preroll) is undefined, or is already found at index 0, then the original cdns will be returned.  Otherwise returns a new Array with primaryCdn at index 0.
 */ export function getPrioritizedCdns(primaryCdn, cdns) {
    if (primaryCdn) {
        var activeCdnIndex = cdns.findIndex(function(e) {
            return e.url === (primaryCdn === null || primaryCdn === void 0 ? void 0 : primaryCdn.url);
        });
        if (activeCdnIndex > 0) {
            // Note: A shallow clone for better performance. If mutation is required in the future, this should be updated to be a deep clone.
            cdns = _to_consumable_array(cdns);
            cdns[activeCdnIndex] = cdns[0];
            cdns[0] = primaryCdn;
        }
    }
    return cdns;
}

//# sourceMappingURL=meta-list-manager.js.map